// extracted by mini-css-extract-plugin
module.exports = {"container":"FailedValidation_container__3GqEi","text":"FailedValidation_text__1WRvg","grid":"FailedValidation_grid__1qm2y","btn":"FailedValidation_btn__2E4Jj"};